import request from '@/api/axios';


// 获取SIM卡基础信息：
export function getCurrentCardBaseInfo(iccid,country) {
    return request({
      url: `/api/customer/v2/getCurrentCardBaseInfo/${iccid}/${country}`,
      method: 'get'
    });
  }

// 获取请求国家
export function getIpAddress(token) {
    return request({
        url: '/api/customer/v1/getIpAddress?token=' + token,
        method: 'get'
    });
}


// 获取请求国家
export function activateSim(iccid) {
    return request({
        url: '/api/sim/v2/activateSim/' + iccid,
        method: 'post'
    });
}

// App 是否可领取体验套餐。路由没有 country 时不传该参数。
export function canClaim(country) {
    const name = String(country || '').trim();
    const params = {};
    if (name) params.country = name;
    return request({
        url: '/api/sim/v2/canClaim',
        method: 'get',
        params,
    });
}

// 领取体验套餐
export function claimPackage(data) {
    return request({
        url: '/api/sim/v2/ClaimPackage',
        method: 'post',
        data,
    });
}


